import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }

import DefaultHeader from "@/components/Headers/DefaultHeader.vue";
import DefaultFooter from "@/components/Footers/DefaultFooter.vue";
import { useRouter, useRoute } from "vue-router";
import Social from '@/components/social/Social.vue'
import MenuBottom from '@/components/menu/MenuBottom.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Default',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_layout, {
      class: _normalizeClass(["layout-default", [_unref(route).meta.layoutClass]]),
      id: "layout-default"
    }, {
      default: _withCtx(() => [
        _createVNode(DefaultHeader),
        _createVNode(_component_a_layout_content, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_router_view)
            ])
          ]),
          _: 1
        }),
        _createVNode(DefaultFooter),
        _createVNode(Social)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(MenuBottom)
  ]))
}
}

})